import { useMutation, useQueryClient } from "@tanstack/react-query";
import { forceDeleteAllOrgStructureItems as apiFn } from "../../api/apiOrgStructureItems";
import { useSnackbar } from "notistack";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useForceDeleteAllOrgStructureItems() {
    const qc = useQueryClient(); const { enqueueSnackbar } = useSnackbar();
    const { mutate: forceDeleteAllOrgStructureItems, isPending: isForceDelete } = useMutation({
        mutationFn: (req) => apiFn(req),
        onSuccess: (r) => { enqueueSnackbar(r.message, { variant: "success" }); qc.invalidateQueries({ queryKey: ["orgStructureItems"] }); },
        onError: (err) => { enqueueSnackbar(getErrorMessageFromAxiosError(err), { variant: "error" }); },
    });
    return { forceDeleteAllOrgStructureItems, isForceDelete };
}
